import React from 'react';
import { NAVBAR_LOGOS } from '../../constants/staticAssets';

/**
 * Logo component that displays the app logo
 * @param {string} variant - 'icon' for small icon, 'horizontal' for full logo, 'both' for both (used in sidebar)
 * @param {string} className - optional className for styling
 */
const Logo = ({ variant = 'horizontal', className }) => {
    if (variant === 'both') {
        // Render both logos - visibility controlled by parent CSS (used in sidebar hover states)
        return (
            <>
                <img 
                    className="logo-icon" 
                    src={NAVBAR_LOGOS.icon} 
                    alt="Experience" 
                />
                <img 
                    className="logo-horizontal" 
                    src={NAVBAR_LOGOS.horizontal} 
                    alt="Experience" 
                />
            </>
        );
    }
    
    const logoSrc = variant === 'icon' ? NAVBAR_LOGOS.icon : NAVBAR_LOGOS.horizontal;
    
    return (
        <img 
            className={className} 
            src={logoSrc} 
            alt="Experience" 
        />
    );
};

export default Logo;
